const transformVideoStream = false
window.initVideoSrc(transformVideoStream)

const menuIndex = 0
window.initMenu(menuIndex)
